<!-- Show Common Header only when an activity is launched -->
<common-header *ngIf="selectedActivity" (onLogout)="logOut()" [ngClass]="{'full-screen': showFullScreen}" [isSCompContent]="isSCompContent"></common-header>
<!-- Show Assignment Only Component Banner when the component has 'assignments-only' flag set to true -->
<div *ngIf="showAssignmentOnlyComponentBanner && isTeacher"
        class="assignments-only-banner d-flex align-items-center justify-content-between flex-column flex-sm-row p-3 py-sm-2 px-sm-3">
        <div class="assignments-only-banner-header d-flex align-items-start justify-content-start w-100">
                <i class="fa fa-exclamation-triangle warning-icon mr-3 mt-1 h-100" aria-hidden="true"></i>
                <span class="assignments-only-desc">{{'SHARED.LO_RENDERER.ASSIGNMENTS_ONLY_BANNER.DESC' |
                        translate}}</span>
                <button class="close-btn d-sm-none"
                        [attr.aria-label]="'SHARED.LO_RENDERER.ASSIGNMENTS_ONLY_BANNER.CLOSE' | translate"
                        qid="t-lr-aocb-btn-1" (click)="closeAssignmentOnlyComponentBanner(false)">&times;</button>
        </div>
        <div class="assignments-only-banner-footer d-flex justify-content-end align-items-center w-100">
                <button class="btn btn-main-color-1-bordered show-btn-banner d-flex align-items-center justify-content-center mr-3 mt-3 mt-sm-0"
                        (click)="closeAssignmentOnlyComponentBanner(true)" qid="t-lr-aocb-btn-2"
                        [attr.aria-label]="'SHARED.LO_RENDERER.ASSIGNMENTS_ONLY_BANNER.DONT_SHOW_AGAIN' | translate">{{'SHARED.LO_RENDERER.ASSIGNMENTS_ONLY_BANNER.DONT_SHOW_AGAIN'|
                        translate}}</button>
                <button class="close-btn d-none d-sm-block"
                        [attr.aria-label]="'SHARED.LO_RENDERER.ASSIGNMENTS_ONLY_BANNER.CLOSE' | translate"
                        qid="t-lr-aocb-btn-1" (click)="closeAssignmentOnlyComponentBanner(false)">&times;</button>
        </div>
</div>

<div class="banner-wrapper" [ngClass]="{'full-screen': showFullScreen}">
        <message-banner *ngIf="showBanner"></message-banner>
</div>
<div class="content-container" [ngClass]="{'lti-result-screen': showLtiResultScreen, 'scomp-container': isSCompContent}"
        [hidden]="showLitmusUnavailableScreen">
        <div *ngIf="!isSCompContent || (isAssignedLO && (userData?.role !== 'student' || userData?.launchType === 'lti'))" class="nav-container d-flex my-1">
                <a *ngIf="!isHideBackButton" class="mr-2 back-btn btn btn-link d-inline-flex align-items-center"
                        href="javascript:void(0)" qid="lo-renderer-bck-btn" (click)="navigateBack()"
                        [attr.aria-label]="'SHARED.LO_RENDERER.BACK' | translate">
                        <i class="fa fa-chevron-left mr-2 back-btn-icon" aria-hidden="true"></i><span
                                class="back-btn-text">{{'SHARED.LO_RENDERER.BACK' | translate }}</span>
                </a>
                <span *ngIf="!isHideBackButton" class="vertical-rule mx-2 my-3"></span>
                <img class="toc-hamburger-btn mx-2 open-sidebar-btn px-0" [src]='imageBasePath + "assets/img/"+tocIcon'
                        aria-hidden="true" (click)="toggleSideBar()" alt="">
                <a class="open-sidebar open-sidebar-btn" id="selectedActivitySidebarBtn" qid="lo-renderer-toggle-btn-9" (click)="toggleSideBar()"
                        href="javascript:void(0);" title="{{selectedActivity?.name}}">
                        <span *ngIf="!(hideSequencing === 'true')">
                                {{lessonSequence}}
                        </span>
                        {{selectedActivity?.name}}
                </a>
        </div>
        <div [hidden]="showResultScreen" class="activity-container">
                <router-outlet></router-outlet>
        </div>
</div>